import './instagram_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramCommentContent extends Monitoring.Models.SocialContents.InstagramContent

  author: ->
    @data().from || {}

  image: ->
    @avatar()

  content: ->
    @data().text

  getRootParentId: ->
    @data().parent_id

  hasRelated: ->
    false
